import { render, staticRenderFns } from "./ManageExtraSubjects.vue?vue&type=template&id=07174a0c"
import script from "./ManageExtraSubjects.vue?vue&type=script&lang=js"
export * from "./ManageExtraSubjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports